@if (isVisible()) {
  <div class="fb-page-cta">
    <div class="fb-page-cta__header">
      <span class="fb-page-cta__title">
        {{ 'cta.title' | translateIn }}
      </span>

      <button
        type="button"
        puButton
        size="s"
        uiType="quaternary"
        class="fb-page-cta__close"
        [onlyIcon]="true"
        (click)="close()"
      >
        <pu-icon
          iconName="close"
          size="12"
        />
      </button>
    </div>

    <div class="fb-page-cta__body">
      <fb-cta-list
        [ctas]="ctas()"
        [surface]="CtaSurface.Page"
        (ctaSelected)="ctaSelected.emit($event)"
      />
    </div>
  </div>
}
